module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_11-dbe2ac7705afc5f03ef4b6efcb8ded7f.jpg";